import { PageWrapper } from "components/design-system/PageWrapper";

export default function BetaPage() {
  return (
    <PageWrapper showFooter={false}>
      <h1>Beta Page</h1>

      <p>Welcome to the beta for SmartWallet.</p>

      <h1>Onboarding</h1>
    </PageWrapper>
  );
}